import { createContext } from "react"
import { AuthReducerInit } from "@Context/v3/inits"

// this is for the context is for the user login
const AuthContext = createContext({
  state: AuthReducerInit(),
  dispatch: () => null,
})

export default AuthContext